import { WeekRangeObj } from "../types";

const getValidatedWeekRange = (
  minimumWeeks: number,
  maximumWeek: number,
): WeekRangeObj | undefined => {
  if (maximumWeek === 0 || minimumWeeks === 0) return undefined;

  if (minimumWeeks > maximumWeek) return undefined;

  if (!Number.isInteger(minimumWeeks) || !Number.isInteger(maximumWeek))
    return undefined;

  if (minimumWeeks < 0 || maximumWeek < 0) return undefined;

  const weeksRange = {
    startWeek: minimumWeeks,
    endWeek: maximumWeek,
  };

  return weeksRange;
};

export default getValidatedWeekRange;
